<div class="d-flex flex-column align-items-center">
  <div
    class="d-flex flex-column text-left"
    style="flex-basis: 50%; width: 45rem; position: relative"
  >
    <h1 class="card-title font-weight-bold" id="card-title">Pricing</h1>
  </div>
  <div
    class="d-flex card border-danger shadow"
    style="border-left: 6px solid; width: 45rem"
  >
    <div class="card-body">
      <div class="d-flex flex-row justify-content-between">
        <div class="d-flex flex-column">
          <span
            class="card-title text-danger display-3 font-weight-bold"
            id="card-title"
          >
            TRIAL
          </span>
          <span class="card-text">
            Access to <b>all features</b> for {{ trialPeriod }}
          </span>
        </div>
        <div class="d-flex flex-column align-items-end float-right">
          <span class="display-3 font-weight-bold">FREE!</span>
          <span class="card-subtitle-1 font-weight-bold">FOR ONE USER</span>
        </div>
      </div>
      <div class="d-flex flex-row float-right mt-4">
        <button
          type="button"
          class="btn btn-lg btn-outline-danger"
          (click)="navigateToForm(billingLevel.TRIAL)"
        >
          Start Free Trial
        </button>
      </div>
    </div>
  </div>
  <div
    class="d-flex card border-primary shadow mt-4"
    style="border-left: 6px solid; width: 45rem"
  >
    <div class="card-body">
      <div class="d-flex flex-row justify-content-between">
        <div class="d-flex flex-column">
          <span
            class="card-title text-primary display-3 font-weight-bold"
            id="card-title"
          >
            BUY PC*MILER
          </span>
          <span class="card-text">
            Comprehensive set of routing options and planning tools with:
            <b
              >Real-time traffic & weather display Quarterly map & toll data
              updates </b
            >and <b>Street-level routing in the U.S. & Canada</b>
          </span>
        </div>
        <div class="d-flex flex-column align-items-end float-right">
          <span class="display-3 font-weight-bold">
            {{ featureCost | displayCurrency : displayCurrency }}</span
          >
          <span class="card-subtitle-1 font-weight-bold">A MONTH PER USER</span>
          <div class="d-flex flex-row float-right mt-4">
            <button
              type="button"
              class="btn btn-lg btn-primary"
              (click)="navigateToForm(billingLevel.PREMIUM)"
            >
              Get PC*MILER Today
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>

  <div class="d-flex flex-column form-labels text-center p-4">
    <span>
      We accept Visa, MasterCard, and American Express credit cards. All credit
      card information is confidential and securely transmitted online.*
    </span>
    <span class="font-italic"
      >*Applicable sales taxes apply on all orders.</span
    >
  </div>
  <!--Features list-->
  <div
    class="d-flex flex-column text-left"
    style="flex-basis: 50%; width: 45rem; position: relative"
  >
    <h1 class="card-title font-weight-bold" id="card-title">Features</h1>
  </div>
  <div>
    <div class="accordion featureAccordion p-2" id="accordion">
      <div
        class="p-2"
        *ngFor="let featureSet of featureData['value']; let i = index"
      >
        <div class="card shadow px-3">
          <div
            class="card-header"
            role="button"
            [attr.id]="'heading' + i"
            data-toggle="collapse"
            [attr.data-target]="'#card' + i"
            aria-expanded="false"
            [attr.aria-controls]="'card' + i"
          >
            <h6 class="mb-0" [attr.id]="'collapsible-group-item-' + i">
              {{ featureSet["category"] }}
            </h6>
          </div>
          <div
            [attr.id]="'card' + i"
            class="collapse"
            [attr.aria-labelledby]="'heading' + i"
            data-parent="#accordion"
          >
            <ul class="card-body d-flex flex-row flex-wrap">
              <li
                class="column-2"
                *ngFor="let feature of featureSet?.features; let j = index"
              >
                {{ feature?.value }}
              </li>
            </ul>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
